/**
 * Shared GST state / place-of-supply helpers — Shakthi Power's registered
 * state is Tamil Nadu, so any invoice raised for an entity in another state
 * is an interstate (IGST) supply rather than intrastate (CGST+SGST).
 */

export const SUPPLIER_STATE_NAME = 'Tamil Nadu'

export const GST_STATE_CODES: Record<string, string> = {
  'Andhra Pradesh': '37',
  'Gujarat': '24',
  'Karnataka': '29',
  'Maharashtra': '27',
  'Rajasthan': '08',
  'Tamil Nadu': '33',
  'Telangana': '36',
  'Uttar Pradesh': '09',
}

export const STATE_OPTIONS = Object.entries(GST_STATE_CODES).map(([name, code]) => `${name} (${code})`)

export const SUPPLIER_STATE = `${SUPPLIER_STATE_NAME} (${GST_STATE_CODES[SUPPLIER_STATE_NAME]})`

const cleanStateName = (state?: string) => (state || '').split('(')[0].trim()

/** "Karnataka" or "Karnataka (29)" -> "Karnataka (29)"; falls back to the bare name if the code is unknown. */
export function formatPlaceOfSupply(state?: string): string {
  const clean = cleanStateName(state)
  if (!clean) return SUPPLIER_STATE
  const code = GST_STATE_CODES[clean]
  return code ? `${clean} (${code})` : clean
}

/** True when the given state is Shakthi Power's own state (Tamil Nadu) — i.e. an intrastate supply. */
export function isIntraState(state?: string): boolean {
  const clean = cleanStateName(state).toLowerCase()
  return !clean || clean === SUPPLIER_STATE_NAME.toLowerCase()
}
